// Js page single product \\

const dateSingle = document.querySelector('.product-single');
const flickitySslider = document.querySelector('.product-thumbnails');

if(dateSingle) {

    /* Add placeholder in input */
    const dateInputSingle = document.querySelector('.date-active-product-single input');
    if (dateInputSingle) {
        dateInputSingle.placeholder = "Data de ativação *";
    }

    if (flickitySslider) {
        setTimeout(() => {
            flickitySslider.style.opacity = '1';
        }, "500");
    }
}


// Changing small image to large image \\

const imageGalleryfull = document.querySelector('.woocommerce-product-gallery__wrapper .woocommerce_single_product_image_main img');
const sourceGalleryfull = document.querySelector('.woocommerce-product-gallery__wrapper .woocommerce_single_product_image_main source');
const contentImage = document.querySelectorAll('.woocommerce-product-gallery__wrapper .single_product_image');

if (imageGalleryfull && contentImage.length > 0) {
    contentImage.forEach(function(item) {
        item.addEventListener('click', () => {
            const imageGallerySmall = item.querySelector('img');
            if (imageGallerySmall) {
                const urlSmall = imageGallerySmall.getAttribute('src');
                imageGalleryfull.setAttribute('srcset', urlSmall);
                if (sourceGalleryfull) {
                    sourceGalleryfull.setAttribute('srcset', urlSmall);
                }
            }
        });
    });
}


// const productPrice = jQuery('#sigle_product_price');
const productPrice = document.getElementById('sigle_product_price');

if( productPrice ) {
    jQuery("#calc_shipping_state").on('change', () => {
        jQuery(".calc_shipping_description").html( 'Carregando...' );
        const data = {
            country: jQuery("#calc_shipping_cc").val(),
            state: jQuery("#calc_shipping_state").val(),
            product_id: jQuery(".single_add_to_cart_button").val(),
            action: 'change_select_shipping_single_product',
        };

        jQuery.ajax({
            type: 'POST',
            url: wcParams.adminAjax,
            data: data,
            dataType: "json",
            success: function ( data ) {
                jQuery(".calc_shipping_description").html(data['html']);
            }
        });
    });


    const qtyInput = jQuery(".qty");
    
    // Function to update price based on quantity
    const updatePriceByQuantity = () => {
        const qtyValue = Number.parseInt( qtyInput.val() ) || 1;
        const productValueHtml = jQuery('.cart .price .woocommerce-Price-amount bdi, .woocommerce-variation-add-to-cart .price .woocommerce-Price-amount bdi');
        const productValue = Number.parseFloat( jQuery('#sigle_product_price').val() );
        const productValueResult = qtyValue * productValue;

        productValueHtml.html( '<span class="woocommerce-Price-currencySymbol">$</span>' + productValueResult.toFixed( 2 ) );
    };
    
    qtyInput.on('change input', updatePriceByQuantity);
}

// Handle variable products price update on quantity change
jQuery(document).ready(function($) {
    const $form = $('.variations_form');

    if ($form.length) {
        const $qtyInput = $('.qty');

        const updateVariablePrice = () => {
            const qty = Number.parseInt($qtyInput.val()) || 1;
            const basePrice = Number.parseFloat($('#variation_product_price').val());
            const $priceContainer = $('.woocommerce-variation-add-to-cart .woocommerce-Price-amount bdi');

            if (basePrice > 0 && $priceContainer.length > 0) {
                const totalPrice = qty * basePrice;
                $priceContainer.html('<span class="woocommerce-Price-currencySymbol">$</span>' + totalPrice.toFixed(2));
            }
        };

        $qtyInput.on('change input', updateVariablePrice);

        $form.on('found_variation', function(event, variation) {
            if (variation.display_price) {
                $('#variation_product_price').val(variation.display_price);
            }
        });

        $form.on('show_variation', function(event, variation) {
            setTimeout(() => {
                updateVariablePrice();
            }, 50);
        });

    }
});



///Anchor

const pageSingleProduct = document.querySelector('.single-product');

if (pageSingleProduct) {
    document.querySelectorAll("a[href^=\"#\"]").forEach((anchor) => {
        anchor.addEventListener("click", function (ev) {
          ev.preventDefault();

          const targetElement = document.querySelector(this.getAttribute("href"));
          targetElement.scrollIntoView({
            block: "center",
            alignToCenter: true,
            behavior: "smooth"
          });
        });
    });
}

const dateActiveProduct = document.querySelector('.date-active-product-single input');

if (dateActiveProduct) {
  dateActiveProduct.addEventListener('click', function(e) {
    e.target.removeAttribute('readonly')

    setTimeout(function() {
      try {
        e.target.showPicker()
      } catch(err) {
        // Navegador bloqueou showPicker() - ignorar
      }
    }, 500)
  })

}

